/*
 * Copyright © 2023 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */
class User {
  static Builder = class {
    setUsername(username) {
      this.username = username;
      return this;
    }

    setGroup(group) {
      this.group = group;
      return this;
    }

    build() {
      return new User(this.username, this.group);
    }
  };

  constructor(username, group) {
    this.username = username;
    this.group = group;
  }
}

export default User;
